import { cn } from "../../lib/utils";

export function LicenseActionButton({ children, ...props }) {
   return (
      <button
         type="button"
         onClick={props.onClick}
         className={
            cn(
               "flex flex-col gap-5 items-start box-border p-5 justify-center w-full h-[120px] cursor-pointer border! border-(--borderColor)! rounded-(--borderRadius)! hover:bg-(--primaryColor)/5! hover:border-(--primaryColor)! hover:text-(--primaryColor)! duration-200",
               props.className
            )
         }
      >
         {children}
      </button>
   );
}